import initializeMobileMenu from './menu';
import initializeStickyHeader from './sticky-header';
import initializeFancyBox from './fancybox';
import initializeForm from './utils/form';
import initializeLazyYoutube from "./utils/lazy-youtube";
import { initializeButtonIconFrontend } from './theme-features/button-icon-dom';
import { initializeTableEnhancements } from './theme-features/table-enhancements';
import initializeCf7Accessibility from './theme-features/cf7-accessibility';
import initializeHeroSlider from './blocks/hero-slider';
import initializeLogoSlider from './blocks/logo-slider';

// import initializeAccordions from "./blocks/accordion";
// import initializeIconBoxes from './blocks/icon-boxes';
import initializeNumbersBlock from './blocks/numbers';
import initializeTeam from './blocks/team';
import initializePostList from './blocks/post-list';
import initializePatrons from './blocks/patrons';
import initializeMembershipDirectory from './blocks/membership-directory';
import initializeIssuesList from './blocks/issues-list';
import initializeMemberAuth from './theme-features/member-auth';
import initializeBannerClickTracking from './blocks/banner-click-tracking';
import initializeSharePopover from './theme-features/share-popover';
// import initializeGallerySection from './blocks/gallery-section';
import initializeGalleryGrid from "./blocks/gallery-grid";
import blockLogotypes from "./blocks/logotypes";
// import initializeBrands from './blocks/brands';
// import initializeGallerySlider from './blocks/gallery-slider';
// import initializeGalleryText from './blocks/gallery-text';
// import initializeIconBoxesAnimation from './blocks/icon-boxes-animation';
// import WooCommerce from './woo'

class App {
    constructor() {
        this.initialize();
    }

    initialize() {
        import('aos/dist/aos.js').then(({ default: AOS }) => {
            AOS.init({
                startEvent: 'load',
                disable: 'mobile',
                once: true,
                duration: 1000
            });
        });
        initializeForm();
        initializeFancyBox();
        initializeMobileMenu();
        initializeStickyHeader();
        initializeLazyYoutube();
        initializeButtonIconFrontend();
        initializeTableEnhancements();
        initializeCf7Accessibility();
        initializeHeroSlider();
        initializeLogoSlider();

        // initializeAccordions();
        // initializeCollapse();
        // initializeIconBoxes();
        initializeNumbersBlock();
        initializeTeam();
        initializePostList();
        initializePatrons();
        initializeMembershipDirectory();
        initializeIssuesList();
        initializeMemberAuth();
        initializeBannerClickTracking();
        initializeSharePopover();
        // initializeGallerySection();
        initializeGalleryGrid();
        blockLogotypes();
        // initializeBrands();
        // initializeGallerySlider();
        // initializeGalleryText();
        // initializeIconBoxesAnimation();

        // const Woo = new WooCommerce();
    }
}

function initializeApp() {
    const app = new App();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    initializeApp();
}
